import { INotificationGroupType, INotificationItem } from "@multiweb/types/contracts";
import { CancellationToken } from "Global/Base/Promises/CancellationTokenSource";

export type NotificationListener = () => Promise<void>;

/**
 * Umožňuje manipulovat s daty (čtení, editace) notifikací na rozhraní webové služby
 * @includeToDoc
 */
export interface INotificationClient {
    /**
     * Načte všechny dostupné typy notifikací spolu s dalšími konfiguračními informacemi
     * @param cancellationToken Umožňuje zrušit stávající dotaz
     * @returns Kolekce typů notifikací
     */
    getNotificationGroups(cancellationToken?: CancellationToken): Promise<readonly Readonly<INotificationGroupType>[]>;
    /**
     * Zjistí, zda v dané skupině notifikací existuje nějaká nepřečtená
     * @param groupName Název skupiny notifikací
     * @param cancellationToken Umožňuje zrušit stávající dotaz
     */
    existsUnreadNotification(groupName: string, cancellationToken?: CancellationToken): Promise<boolean>;
    /**
     * Načte všechny notifikace určité skupiny
     * @param groupName Název skupiny notifikací
     * @param onlyUnread Zda se mají načítat pouze nepřečtené notifikace
     * @param startIndex Od jaké pozice se mají načítat data
     * @param itemsCount Kolik položek se má načíst
     * @param cancellationToken Umožňuje zrušit stávající dotaz
     */
    getNotificationItems(groupName: string, onlyUnread: boolean, startIndex: number, itemsCount: number, cancellationToken?: CancellationToken): Promise<readonly Readonly<INotificationItem>[]>;
    /**
     * Označí notifikaci jako přečtenou nebo nepřečtenou
     * @param notificationId Identifikátor notifikace
     * @param markAsRead Zda se má označit jako přečtená
     * @param cancellationToken Umožňuje zrušit stávající dotaz
     */
    setNotificationAsRead(notificationId: number, markAsRead: boolean, cancellationToken?: CancellationToken): Promise<void>;
    /**
     * Označí všechny notifikace dané skupiny jako přečtené
     * @param notificationGroupId Identifikátor skupiny
     * @param cancellationToken Umožňuje zrušit stávající dotaz
     */
     setGroupNotificationsAsRead(notificationGroupId: string, cancellationToken?: CancellationToken): Promise<void>;
    /**
     * Registruje listener pro naslouchání změnám položek notifikací (vznik, změna, smazání).
     * @param listener Listener volaný při změně notifikací
     */
    subscribeNotificationChange(listener: NotificationListener): Promise<void>;
    /**
     * Odregistruje listener pro naslouchání změnám položek notifikací (vznik, změna, smazání).
     * @param listener Listener volaný při změně notifikací
     */
    unsubscribeNotificationChange(listener: NotificationListener): Promise<void>;
}
